// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const userApi = createApi({
    reducerPath: 'userApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL,
    }),
    endpoints: (builder) => ({
        getUserInfo: builder.query({
            query: () => ({ url: `/userinfodata`, headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`
            }}),
        }),
        refreshToken: builder.query({
            query: () => ({ url: `/refresh_token`, method: 'POST', body: '', credentials: 'include'}),
        }),
    })
})

export const { useLazyGetUserInfoQuery, useGetUserInfoQuery, useLazyRefreshTokenQuery } = userApi;